export interface Category {
  nameKey: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    nameKey: "categories.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Bright%20red%20running%20sneaker%20on%20polished%20concrete%20floor%2C%20dynamic%20side%20angle%2C%20urban%20streetwear%20product%20photography%2C%20crisp%20studio%20lighting%2C%20bold%20red%20and%20grey%20tones%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-shoes&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Pastel%20pink%20oversized%20hoodie%20neatly%20folded%20on%20white%20linen%20fabric%2C%20soft%20dreamy%20lighting%2C%20feminine%20minimal%20aesthetic%2C%20gentle%20shadows%2C%20clean%20product%20photography%2C%20warm%20airy%20tones&width=400&height=400&seq=cat-hoodies&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Black%20graphic%20t-shirt%20hanging%20on%20wooden%20clothes%20hanger%20against%20white%20brick%20wall%2C%20moody%20editorial%20fashion%20photography%2C%20soft%20directional%20lighting%2C%20urban%20minimal%20style%2C%20high%20contrast&width=400&height=400&seq=cat-tshirts&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-bill-line",
    image: "https://readdy.ai/api/search-image?query=Brown%20leather%20biker%20jacket%20on%20dark%20charcoal%20background%2C%20dramatic%20moody%20studio%20lighting%2C%20premium%20fashion%20product%20photography%2C%20rich%20leather%20texture%2C%20cinematic%20tones&width=400&height=400&seq=cat-jackets&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-walk-line",
    image: "https://readdy.ai/api/search-image?query=Olive%20green%20cargo%20pants%20laid%20flat%20on%20grey%20concrete%20surface%2C%20rugged%20utilitarian%20product%20photography%2C%20natural%20window%20light%2C%20earthy%20tones%2C%20clean%20minimal%20composition&width=400&height=400&seq=cat-pants&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Navy%20blue%20baseball%20cap%20floating%20against%20soft%20peach%20gradient%20background%2C%20minimalist%20studio%20product%20photography%2C%20smooth%20soft%20lighting%2C%20modern%20ecommerce%20aesthetic%2C%20crisp%20clean%20look&width=400&height=400&seq=cat-headwear&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Cozy%20grey%20matching%20tracksuit%20set%20folded%20together%20on%20warm%20beige%20rug%2C%20lifestyle%20flat%20lay%20photography%2C%20soft%20natural%20morning%20light%2C%20neutral%20warm%20tones%2C%20relaxed%20aesthetic&width=400&height=400&seq=cat-sets&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shield-line",
    image: "https://readdy.ai/api/search-image?query=Folded%20white%20and%20grey%20cotton%20underwear%20stack%20on%20soft%20textured%20towel%2C%20bright%20airy%20product%20photography%2C%20gentle%20natural%20light%2C%20clean%20fresh%20minimal%20aesthetic%2C%20spa-like%20calm%20tones&width=400&height=400&seq=cat-underwear&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Green%20and%20white%20football%20soccer%20jersey%20on%20natural%20grass%20field%2C%20outdoor%20sports%20product%20photography%2C%20bright%20daylight%2C%20vibrant%20sporty%20aesthetic%2C%20crisp%20details&width=400&height=400&seq=cat-jersey&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-gift-line",
    image: "https://readdy.ai/api/search-image?query=Gold%20wristwatch%20and%20black%20sunglasses%20arranged%20on%20white%20marble%20surface%2C%20luxury%20flat%20lay%20photography%2C%20soft%20elegant%20lighting%2C%20premium%20minimal%20aesthetic%2C%20refined%20warm%20tones&width=400&height=400&seq=cat-accessories&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    image: "https://readdy.ai/api/search-image?query=Brown%20leather%20backpack%20standing%20on%20rustic%20wooden%20bench%2C%20outdoor%20adventure%20product%20photography%2C%20golden%20hour%20warm%20lighting%2C%20earthy%20natural%20tones%2C%20detailed%20texture&width=400&height=400&seq=cat-bags&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link-m",
    image: "https://readdy.ai/api/search-image?query=Braided%20brown%20leather%20belt%20coiled%20on%20dark%20leather%20surface%2C%20close-up%20product%20photography%2C%20warm%20moody%20lighting%2C%20rich%20texture%20detail%2C%20premium%20minimalist%20style&width=400&height=400&seq=cat-belts&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20fresh%20citrus%20slice%20on%20cream%20background%2C%20elegant%20product%20photography%2C%20soft%20natural%20light%2C%20fresh%20vibrant%20tones%2C%20luxury%20minimal%20aesthetic&width=400&height=400&seq=cat-perfumes&orientation=squarish&nocache=true",
  },
  {
    nameKey: "categories.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Woven%20basket%20filled%20with%20assorted%20fashion%20accessories%20and%20textiles%2C%20cozy%20flat%20lay%20photography%2C%20warm%20natural%20lighting%2C%20earthy%20neutral%20tones%2C%20organized%20aesthetic&width=400&height=400&seq=cat-other&orientation=squarish&nocache=true",
  },
];